import {Component, OnInit} from '@angular/core';
import {Account, AccountDetails} from '../..//models/account';
import {AccountService} from '../../services/account.service';
import {Group} from '../../models/group';
import {GroupService} from '../../services/group.service';
import {AccountFormComponent} from '../account-form/account-form.component';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AccountDeleteComponent} from '../account-delete/account-delete.component';
import {Address} from '../../models/address';
import {AccountFilter} from '../../models/filters/account-filter';
import {environment} from '../../../environments/environment';
import {AccountUpdateComponent} from '../account-update/account-update.component';
import {AccountDTO} from '../../models/account';
import {fadeInAndOut} from '../../utils/animations-utils';
import {ToastsManager} from 'ng2-toastr';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-accounts',
  animations: [fadeInAndOut()],
  templateUrl: './accounts-list.component.html',
  styleUrls: ['./accounts-list.component.css']
})
export class AccountsListComponent implements OnInit {

  p = 1;      // current page
  total: number;      // total count of records
  itemsPerPage = environment.itemPerPage;       // number of records to display on each page
  listLoading: boolean;

  filters: AccountFilter;
  groupFilter = 0;
  visibleGroups: Group[];
  listFiltered = false;

  /**
   * Keys : string criterias
   * Values : boolean => true if ascending, false otherwise
   */
  sortingCriterias: Map<string, boolean> = new Map();

  /** Accounts to display in table */
  accounts: AccountDTO[];

  /** Data for modals */
  accountToModify: AccountDetails;
  accountToDelete: Account;
  deleteModal: NgbModalRef;
  formModal: NgbModalRef;
  downloading = false;

  constructor(private accountService: AccountService,
              private groupService: GroupService,
              private modalService: NgbModal,
              private toast: ToastsManager,
              private translateService: TranslateService) {
  }

  /**
   * Loads a list of accounts to display in the table
   * Also loads a list of groups and sucbscription plans to display in the filters fields.
   */
  ngOnInit() {
    this.filters = new AccountFilter();
    if (localStorage.getItem('itemsPerPage')) {
      this.itemsPerPage = parseInt(localStorage.getItem('itemsPerPage'), 10);
    }
    this.getAccounts(1);
    this.loadVisibleGroups();
  }

  /**
   * Create a new empty object for filtering attachment points
   * Retrieve first page
   */
  clearFilters() {
    this.filters = new AccountFilter();
    this.listFiltered = false;
    this.reloadList();
  }

  /**
   * Sorting system function as follow
   * On first click on a criteria => add the criteria as ascending
   * On second click => put the critiera to descending
   * On third click => remove the criteria from the map
   */
  updateSortingCriterias(criteria: string) {
    if (this.sortingCriterias.has(criteria)) {
      if (this.sortingCriterias.get(criteria)) {   // criteria is present as true => switch to false
        this.sortingCriterias.set(criteria, !this.sortingCriterias.get(criteria));
      } else {    // criteria present as false => delete it
        this.sortingCriterias.delete(criteria);
      }
    } else {
      this.sortingCriterias.set(criteria, true);
    }
  }

  changeItemCount(value) {
    this.itemsPerPage = value;
    this.reloadList();

    localStorage.setItem('itemsPerPage', value);
  }

  sortBy(criteria: string) {
    this.updateSortingCriterias(criteria);
    this.reloadList();
  }

  /**
   * Reload lists according to filters, sorting criterias from the first page
   */
  reloadList() {
    this.listFiltered = false;
    Object.values(this.filters).forEach(value => {
      if (value) {
        this.listFiltered = true;
      }
    });
    this.getAccounts(1);
  }

  /**
   * Load all accounts
   */
  getAccounts(page: number): void {
    this.listLoading = true;
    this.p = page;
    this.accountService.getPaginatedFilteredSortedAccountsList(
      this.p,
      this.itemsPerPage,
      this.filters,
      this.sortingCriterias,
      this.groupFilter)
      .subscribe(data => {
        this.accounts = data.res;
        this.total = data.headers.get('x-total-count');
        this.listLoading = false;
      });
  }

  /**
   * Load an array of groups visible with the authentified user profile
   */
  loadVisibleGroups(): void {
    this.groupService.loadVisibleGroups().subscribe(visibleGroups => this.visibleGroups = visibleGroups);
  }

  /**
   * On new account creation display a modal form
   */
  onNewClick(): void {
    this.formModal = this.modalService.open(AccountFormComponent, {size: 'lg', backdrop: 'static'});
    this.formModal.componentInstance.creationMode = true;
    this.formModal.componentInstance.account = {} as AccountDetails;
    // this.formModal.componentInstance.onUpdateValidation.subscribe(() => this.accountHasBeenUpdated());

  }

  onUpdateClick(account: Account): void {
    this.accountService.getAccountDetails(account).subscribe(details => {
      this.accountToModify = details;

      if (this.accountToModify.address === undefined) {
        this.accountToModify.address = {} as Address;
      }

      this.formModal = this.modalService.open(AccountUpdateComponent, {size: 'lg', backdrop: 'static'});
      this.formModal.componentInstance.account = this.accountToModify;
      this.formModal.componentInstance.onValidation.subscribe(() => this.getAccounts(1));
    });

  }

  onDeleteClick(account: Account): void {
    this.deleteModal = this.modalService.open(AccountDeleteComponent, {centered: true});
    this.deleteModal.componentInstance.account = account;

    this.deleteModal.componentInstance.onDeleteValidation.subscribe(() => this.accountHasBeenDeleted());
  }

  /**
   * Called when the user has confirmed his wish to delete an account
   */
  accountHasBeenDeleted() {
    this.accountToDelete = null;
    this.getAccounts(1);
  }

  onGroupChange() {
    this.reloadList();
  }

  downloadXLSFile() {
    this.downloading = true;
    this.accountService.downloadXLSFile(
      this.p,
      this.itemsPerPage,
      this.filters,
      this.sortingCriterias,
      this.groupFilter)
      .subscribe(isTruncated => {
        if (isTruncated) {
          this.toast.warning(this.translateService.instant('common.downloadOk'));
        } else {
          this.toast.success(this.translateService.instant('common.downloadTruncated'));
        }
        this.downloading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/accounts/accounts-list/accounts-list.component.ts